import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import APIRequest from '../../../../Services/commonAPIConsumer';
import { useSelector } from 'react-redux';
import { currentSelectedLanguage, restoreDefaults, storeSettingsData } from '../../../../StateManagement/actions';
import { useDispatch } from 'react-redux';

export const useSubmitSettings = () => {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const settingFor = useSelector(state => state.settings.settingFor);
  const settings = useSelector(state => state.settings);
  const searchedUser = useSelector((state) => state.settings.searchedUser);
  const userDetails = useSelector(state => state.settings.AdminTab.settingsData);
  const excludeControls = useSelector((state) => state.settings.excludeControls);
  const searchedCompany = useSelector(
    (state) => state.settings.searchedCompany
  );
  const isRestoredToDefaults = useSelector((state) => state.settings.restoreDefaults);
  const userRole = localStorage.getItem("UserRole");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tabMap = {
    'Personal': 'personalTab',
    'Company': 'companyTab',
    'Admin': 'AdminTab'
  };

  function customUpdateCommonSettingsData(commonSettings) {
    let ManageKeyValue = "";
    const LandingPage = commonSettings.find(s => s.type === "LandingPage");
    const ManageItem = commonSettings.find(s => s.type === "LandingPage_ManageItem");
    if (LandingPage?.isDataChanged || ManageItem?.isDataChanged) {
      if (LandingPage?.keyValue.includes("Manage")) {
        ManageKeyValue = `${LandingPage?.keyValue.split('_')[0]}_${ManageItem?.keyValue}`;
        commonSettings = commonSettings.map(s => {
          if (s.type === "LandingPage") {
            return {
              ...s,
              keyValue: ManageKeyValue,
              isDataChanged: ManageItem?.isDataChanged || s?.isDataChanged,
            };
          }
          return s;
        }).filter(s => s.type !== "LandingPage_ManageItem");
      }
    }

    const EDisclosure = commonSettings.find(s => s.type === "EDisclosure");
    if (EDisclosure?.isDataChanged) {
      commonSettings = commonSettings.map(s => {
        if (s.type === "TermsOfService") {
          return {
            ...s,
            overrideUserSetting: EDisclosure?.overrideUserSetting,
            lockSetting: EDisclosure?.lockSetting,
            isDataChanged: EDisclosure?.isDataChanged,
          };
        }
        return s;
      });
    }

    if (settingFor != "Admin") {
      commonSettings = commonSettings.map(s => {
        if (s.type === "MaxPagesPerRPD" || s.type === "ImageResolution") {
          return {
            ...s,
            isDataChanged: s.keyValue !== s.prevValue,
          };
        }
        return s;
      });

      if (excludeControls?.length > 0) {
        const filteredExcludeControls = excludeControls.filter(
          type => type !== "MaxPagesPerRPD" && type !== "ImageResolution"
        );
        commonSettings = commonSettings.filter(s => !filteredExcludeControls.includes(s.type));
      }
    }
    return commonSettings;
  }

  const submitChangedData = async (configLevel, searchedUserName) => {
    const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
    const isDirectSend = settings[tabKey]?.selectedTab === "DirectSendDefaults";
    const isContentSecurity = settings[tabKey]?.selectedTab === "ContentSecurity";

    try {
      let commonSettings = [];
      let l1Settings = [];
      let l2Settings = [];
      let l3Settings = [];
      let cipherTextSettings = [];
      let floatingTextSettings = [];



      if (isDirectSend) {
        commonSettings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.commonSettings || [];
        l1Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.l1 || [];
        l2Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.l2 || [];
        l3Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.l3 || [];
      } else if (isContentSecurity) {
        commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
        cipherTextSettings = settings[tabKey]?.settingsData[0]?.cipherText;
        floatingTextSettings = settings[tabKey]?.settingsData[0]?.floatingText;
      } else {
        commonSettings = settings[tabKey]?.settingsData || [];
      }


      commonSettings = customUpdateCommonSettingsData(commonSettings);


      const commonSettingsChanged = commonSettings
        .filter(setting => setting?.isDataChanged)
        .map((setting) => {
          const item = {
            type: setting.type,
            keyvalue: setting.keyValue ? setting.keyValue.trim() : setting.keyValue,
            // Responsible for ensuring IPChangeDetection never sends keyCollection
            keyCollection: setting.type === "IPChangeDetection" ? [] : (setting.keyCollection || []),
            [isDirectSend || isContentSecurity ? 'isOverride' : 'overrideUserSetting']: setting[isDirectSend || isContentSecurity ? 'isOverride' : 'overrideUserSetting'],
            [isDirectSend || isContentSecurity ? 'isLock' : 'lockSetting']: setting[isDirectSend || isContentSecurity ? 'isLock' : 'lockSetting'],
          };
          // Responsible for sending IPChangeDetectionOptions (BanReader, ReAuthenticateReader, NotifySender) to backend
          if (setting.type === "IPChangeDetection") {
            const rawOpts = setting.ipChangeDetectionOptions || setting.IPChangeDetectionOptions || {};
            const opts = {
              banReader: rawOpts.banReader === true || rawOpts.BanReader === true,
              reAuthenticateReader: rawOpts.reAuthenticateReader === true || rawOpts.ReAuthenticateReader === true,
              notifySender: rawOpts.notifySender === true || rawOpts.NotifySender === true,
            };
            item.ipChangeDetectionOptions = opts;
            item.IPChangeDetectionOptions = {
              BanReader: opts.banReader,
              ReAuthenticateReader: opts.reAuthenticateReader,
              NotifySender: opts.notifySender,
            };
          }
          return item;
        });

      let l1SettingsChanged = [];
      let l2SettingsChanged = [];
      let l3SettingsChanged = [];
      let cipherTextSettingsChanged = [];
      let floatingTextSettingsChanged = [];

      const isDirectSendDefaults =
        isDirectSend &&
        (isRestoredToDefaults.l1 ||
          isRestoredToDefaults.l2 ||
          isRestoredToDefaults.l3);
      if (isDirectSend) {

        if (isDirectSendDefaults) {

          if (isRestoredToDefaults.l1) {
            l1SettingsChanged = l1Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

          if (isRestoredToDefaults.l2) {
            l2SettingsChanged = l2Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

          if (isRestoredToDefaults.l3) {
            l3SettingsChanged = l3Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

        } else {

          l1SettingsChanged = l1Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));

          l2SettingsChanged = l2Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));

          l3SettingsChanged = l3Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
        }
      }
      if (isContentSecurity) {
        if (isRestoredToDefaults.cipher || isRestoredToDefaults.floating) {
          if (isRestoredToDefaults.cipher) {
            cipherTextSettingsChanged = cipherTextSettings
              .map((setting) => ({
                type: setting.type,
                keyvalue: setting.keyValue,
                keyCollection: setting.keyCollection,
                isOverride: setting.isOverride,
                isLock: setting.isLock,
              }));
          }
          if (isRestoredToDefaults.floating) {
            floatingTextSettingsChanged = floatingTextSettings
              .map((setting) => ({
                type: setting.type,
                keyvalue: setting.keyValue,
                keyCollection: setting.keyCollection,
                isOverride: setting.isOverride,
                isLock: setting.isLock,
              }));
          }
        } else {
          cipherTextSettingsChanged = cipherTextSettings
            .filter(setting => setting?.isDataChanged)
            .map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }));

          floatingTextSettingsChanged = floatingTextSettings
            .filter(setting => setting?.isDataChanged)
            .map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }));
        }
      }

      let apiSettingsStr = {};
      if (isDirectSend || isContentSecurity) {
        if (isDirectSend) {
          apiSettingsStr = {
            SettingFor: settings.defaultSetting,
            SettingsForType: searchedUser !== "" ? 'User' : settingFor === "Admin" ? "Company" : settingFor,
            CompanyReferenceKey: settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.companyReferenceKey,
            SettingId: settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.id,
            Bowserlaguage: localStorage.getItem("language"),
            LoginUsername: localStorage.getItem('UserName'),
            UserEmail: settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting)?.userEmail,
            CommonSettings: [...commonSettingsChanged],
            L1: [...l1SettingsChanged],
            L2: [...l2SettingsChanged],
            L3: [...l3SettingsChanged],
            Companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : searchedCompany,
            Role: userRole,

          };
        } else if (isContentSecurity) {
          apiSettingsStr = {
            SettingsForType: searchedUser !== "" ? 'User' : settingFor === "Admin" ? "Company" : settingFor,
            CompanyReferenceKey: settings[tabKey].settingsData[0].companyReferenceKey,
            SettingId: settings[tabKey].settingsData[0].id,
            Bowserlaguage: localStorage.getItem("language"),
            LoginUsername: localStorage.getItem("UserName"),
            UserEmail: settings[tabKey].settingsData[0].userEmail,
            CommonContentSecuritySetting: [...commonSettingsChanged],
            CipherText: [...cipherTextSettingsChanged],
            FloatingText: [...floatingTextSettingsChanged],
            Companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : searchedCompany,
            Role: userRole,
          };
        }
        const jsonData = JSON.stringify(apiSettingsStr);
        let response;
        if (isDirectSend) {
          response = await APIRequest.POSTSaveSettings(
            jsonData,
            `${process.env.REACT_APP_API + "/docs/SaveSettingGateway"}`
          );
        } else if (isContentSecurity) {
          response = await APIRequest.POSTSaveSettings(
            jsonData,
            `${process.env.REACT_APP_API + "/docs/SaveContentSecuritySettings"}`
          );

        }
        dispatch(restoreDefaults());

        if (response === "Server maintenance") {
          navigate("/maintenance");
          return { success: false };
        }
        else if (response?.errorMessage) {
          return { success: false };
        }
        else if (response?.statusText === "Inserted") {
          return { success: true };
        }


        return { success: false };
      } else {
        const apiSettingsStr = {
          SettingsForType: searchedUser !== "" ? 'User' : settingFor === "Admin" ? "Company" : settingFor,
          SettingDetails: commonSettingsChanged,
          bowserlaguage: localStorage.getItem("language"),
          userEmail: (settingFor !== "User") ? searchedUser : localStorage.getItem("UserName").toLowerCase(),
          role: userRole,
          companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : searchedCompany,
          loginUsername: localStorage.getItem("UserName").toLowerCase(),
        };

        const response = await APIRequest.POSTSaveSettings(
          JSON.stringify(apiSettingsStr),
          `${process.env.REACT_APP_API + process.env.REACT_APP_API_SaveSettings}`
        );

        if (response === "Server maintenance") {
          navigate("/maintenance");
          return { success: false };
        }
        else if (response && response !== "Failed to fetch") {
          if (!response.errorMessage) {
            //await getActiveTabSettings(tabMenuText, searchedUserName);
            return { success: true };
          } else {
            return { success: false };
          }
        } else {
          return { success: false };
        }
      }
    } catch (error) {
      console.error('Error in submitChangedData:', error);
      return { success: false };
    }
  };

  async function updateUserRoles() {
    try {
      const response = await APIRequest.PUT(
        JSON.stringify(userDetails.filter(userRole => userRole.isDataChanged)),
        `${process.env.REACT_APP_API}${process.env.REACT_APP_API_UpdateUserRoles}`
      );

      if (response === "Server maintenance") {
        navigate("/maintenance");
        return { success: false };
      }

      if (response.errorMessage) {
        handleErrorResponse(response.errorMessage);
        return { success: false };
      }

      if (response.status === 200) {
        const updatedUserDetails = userDetails.map(element => ({
          ...element,
          ...(element.isDataChanged && {
            role: element.roleID,
            prevValue: element.roleID,
            isDataChanged: false
          })
        }));


        dispatch(storeSettingsData({
          outerTabSelected: "Admin",
          innerTabSelected: "Users",
          Settings: updatedUserDetails
        }))

      }
    } catch (error) {
      handleErrorResponse(error.message || 'An error occurred while updating user roles');
      return { success: false };
    }

    return { success: true };
  }

  const handleErrorResponse = (errorMessage) => {
    dispatch(storeSettingsData({
      outerTabSelected: "Admin",
      innerTabSelected: "Users",
      Settings: userDetails
    }))

    return { success: false };
  }


  return {
    submitChangedData,
    updateUserRoles
  };
};

export default useSubmitSettings;
